import controller from './main.controller';
import template from './main.pug';

const MainComponent = {
  template,
  controller,
};

export default MainComponent;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js